module.exports = __webpack_public_path__ + "components/resort-condition/static/next-snowfall-153a09a338fb22fc706b32806d99c760.svg";